import { RegisterPage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router/src/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/register'].update({
        staticData: { title: { page: 'Pages.Register.Header' } },
        component: RegisterPage
    });
};
